var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { DateConverter } from "./../../../../converters/DateConverter";
import { CompanyConfiguration } from "./../../Companies/FileUploadConfiguration/CompanyConfiguration";
export class ComplianceUpload {
  constructor(_data) {
    /**
     */
    __publicField(this, "ClientId");
    /**
     */
    __publicField(this, "ClientName");
    /**
     */
    __publicField(this, "CompanyConfigSnapshot");
    /**
     */
    __publicField(this, "CountryCode");
    /**
     */
    __publicField(this, "ErrorMessage");
    /**
     */
    __publicField(this, "ErrorReason");
    /**
     */
    __publicField(this, "FrequencyType");
    /**
     */
    __publicField(this, "From");
    /**
     */
    __publicField(this, "Id");
    /**
     */
    __publicField(this, "IgnoreOverdue");
    /**
     */
    __publicField(this, "IsDeactivated");
    /**
     */
    __publicField(this, "IsOverdue");
    /**
     */
    __publicField(this, "Period");
    /**
     */
    __publicField(this, "Status");
    /**
     */
    __publicField(this, "To");
    /**
     */
    __publicField(this, "Type");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof ComplianceUpload
     */
    __publicField(this, "$type", "V1.ComplianceUploads.Search.ComplianceUpload");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.ClientId = _data["ClientId"];
      this.ClientName = _data["ClientName"];
      if (_data["CompanyConfigSnapshot"]) {
        const companyConfigSnapshot_ = new CompanyConfiguration();
        this.CompanyConfigSnapshot = companyConfigSnapshot_.init(_data["CompanyConfigSnapshot"]);
      }
      this.CountryCode = _data["CountryCode"];
      this.ErrorMessage = _data["ErrorMessage"];
      this.ErrorReason = ComplianceUploadErrorReason[_data["ErrorReason"]];
      this.FrequencyType = ComplianceUploadFrequencyType[_data["FrequencyType"]];
      this.From = DateConverter.from(_data["From"]);
      this.Id = _data["Id"];
      this.IgnoreOverdue = _data["IgnoreOverdue"];
      this.IsDeactivated = _data["IsDeactivated"];
      this.IsOverdue = _data["IsOverdue"];
      this.Period = _data["Period"];
      this.Status = ComplianceUploadStatus[_data["Status"]];
      this.To = DateConverter.from(_data["To"]);
      this.Type = ComplianceUploadType[_data["Type"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["ClientId"] = this.ClientId;
    _data["ClientName"] = this.ClientName;
    _data["CompanyConfigSnapshot"] = this.CompanyConfigSnapshot ? this.CompanyConfigSnapshot.toJSON() : void 0;
    _data["CountryCode"] = this.CountryCode;
    _data["ErrorMessage"] = this.ErrorMessage;
    _data["ErrorReason"] = ComplianceUploadErrorReason[this.ErrorReason];
    _data["FrequencyType"] = ComplianceUploadFrequencyType[this.FrequencyType];
    _data["From"] = DateConverter.toUtcDateString(this.From);
    _data["Id"] = this.Id;
    _data["IgnoreOverdue"] = this.IgnoreOverdue;
    _data["IsDeactivated"] = this.IsDeactivated;
    _data["IsOverdue"] = this.IsOverdue;
    _data["Period"] = this.Period;
    _data["Status"] = ComplianceUploadStatus[this.Status];
    _data["To"] = DateConverter.toUtcDateString(this.To);
    _data["Type"] = ComplianceUploadType[this.Type];
    return _data;
  }
}
export var ComplianceUploadErrorReason = /* @__PURE__ */ ((ComplianceUploadErrorReason2) => {
  ComplianceUploadErrorReason2["UnknownError"] = "UnknownError";
  ComplianceUploadErrorReason2["UnableToSentToReturnGeneration"] = "UnableToSentToReturnGeneration";
  ComplianceUploadErrorReason2["MissingVatNumberValidation"] = "MissingVatNumberValidation";
  ComplianceUploadErrorReason2["ExternalValidationServiceUnavailable"] = "ExternalValidationServiceUnavailable";
  ComplianceUploadErrorReason2["ExternalValidationServiceUnknownError"] = "ExternalValidationServiceUnknownError";
  ComplianceUploadErrorReason2["ExternalValidationServiceViesUnavailable"] = "ExternalValidationServiceViesUnavailable";
  ComplianceUploadErrorReason2["ExternalValidationServiceCountryUnavailable"] = "ExternalValidationServiceCountryUnavailable";
  ComplianceUploadErrorReason2["MissingVatRate"] = "MissingVatRate";
  ComplianceUploadErrorReason2["ExternalValidationServiceConcurrentLimitReached"] = "ExternalValidationServiceConcurrentLimitReached";
  ComplianceUploadErrorReason2["ExternalValidationServiceTimeout"] = "ExternalValidationServiceTimeout";
  ComplianceUploadErrorReason2["ExternalValidationServiceInvalidInput"] = "ExternalValidationServiceInvalidInput";
  return ComplianceUploadErrorReason2;
})(ComplianceUploadErrorReason || {});
export var ComplianceUploadFrequencyType = /* @__PURE__ */ ((ComplianceUploadFrequencyType2) => {
  ComplianceUploadFrequencyType2["Monthly"] = "Monthly";
  ComplianceUploadFrequencyType2["Quarterly"] = "Quarterly";
  ComplianceUploadFrequencyType2["QuarterlyShifted1"] = "QuarterlyShifted1";
  ComplianceUploadFrequencyType2["QuarterlyShifted2"] = "QuarterlyShifted2";
  ComplianceUploadFrequencyType2["BiMonthly"] = "BiMonthly";
  ComplianceUploadFrequencyType2["FourMonthly"] = "FourMonthly";
  ComplianceUploadFrequencyType2["SixMonthly"] = "SixMonthly";
  ComplianceUploadFrequencyType2["Yearly"] = "Yearly";
  return ComplianceUploadFrequencyType2;
})(ComplianceUploadFrequencyType || {});
export var ComplianceUploadStatus = /* @__PURE__ */ ((ComplianceUploadStatus2) => {
  ComplianceUploadStatus2["New"] = "New";
  ComplianceUploadStatus2["WaitingForFinalize"] = "WaitingForFinalize";
  ComplianceUploadStatus2["InvalidData"] = "InvalidData";
  ComplianceUploadStatus2["SaftCompliance"] = "SaftCompliance";
  ComplianceUploadStatus2["MasterDataSetup"] = "MasterDataSetup";
  ComplianceUploadStatus2["DataUploadFinalized"] = "DataUploadFinalized";
  ComplianceUploadStatus2["DataVatGenerated"] = "DataVatGenerated";
  ComplianceUploadStatus2["SentToReturnGeneration"] = "SentToReturnGeneration";
  ComplianceUploadStatus2["InsufficientCredit"] = "InsufficientCredit";
  ComplianceUploadStatus2["UploadProcessed"] = "UploadProcessed";
  ComplianceUploadStatus2["Error"] = "Error";
  return ComplianceUploadStatus2;
})(ComplianceUploadStatus || {});
export var ComplianceUploadType = /* @__PURE__ */ ((ComplianceUploadType2) => {
  ComplianceUploadType2["IOSS"] = "IOSS";
  ComplianceUploadType2["VAT"] = "VAT";
  return ComplianceUploadType2;
})(ComplianceUploadType || {});
